// fired after a request that changes what the counters show (unread, followed, credit),
// so every counter on the page refreshes at once instead of waiting for the next page
export const COUNTS_CHANGED = 'hs-counts-changed';

export const announceCounts = (res) => {
    window.dispatchEvent(new Event(COUNTS_CHANGED));
    return res;
};
